import React from 'react'
import ConsultaRemessaPagamentoListPageContainer from './ConsultaRemessaPagamentoListPageContainer'

export class ConsultaRemessaPagamentoListPage extends React.Component {
  render() {
    return <ConsultaRemessaPagamentoListPageContainer {...this.props} />
  }
}
